import { Api } from "../config/request";

export default {
  getCapacityChangeRequestData(params) {
    return Api.post("/driver-shift/slot/capacity-change-requests?", params);
  },
  getUserAttributes(action_name) {
    return Api.get(
      "/driver-shift/slot/capacity-change-attributes?" + action_name
    );
  },
  createCapacityChangeRequest(payload, queryParams) {
    return Api.post(
      "/driver-shift/slot/capacity-change-requests/create?" + queryParams,
      payload
    );
  },
  updateCapacityChangeRequest(payload, queryParams) {
    return Api.put(
      "/driver-shift/slot/capacity-change-requests/update?" + queryParams,
      payload
    );
  },
};
